var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationOnIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#F87171;}\r\n\t.st2{fill:#107569;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,18.7v-1h2v-7.5c0-1.3,0.4-2.5,1.3-3.5c0.8-1,1.9-1.6,3.2-1.9V4.1c0-0.3,0.1-0.5,0.3-0.7 c0.2-0.2,0.4-0.3,0.7-0.3s0.5,0.1,0.7,0.3C12.9,3.6,13,3.8,13,4.1v0.7c1.3,0.2,2.4,0.9,3.2,1.9c0.9,1,1.3,2.2,1.3,3.5v7.5h2v1H4.5z  M12,21.6c-0.4,0-0.8-0.2-1.1-0.5c-0.3-0.3-0.5-0.7-0.5-1.2h3.2c0,0.5-0.2,0.9-0.5,1.2C12.9,21.5,12.5,21.6,12,21.6z M7.5,17.7h9 v-7.5c0-1.2-0.4-2.3-1.3-3.2c-0.9-0.9-1.9-1.3-3.2-1.3S9.7,6.2,8.8,7C7.9,7.9,7.5,9,7.5,10.2V17.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 17,
    cy: 8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M17,5c1.7,0,3,1.3,3,3c0,1.7-1.3,3-3,3s-3-1.3-3-3C14,6.3,15.3,5,17,5 M17,4c-2.2,0-4,1.8-4,4s1.8,4,4,4 s4-1.8,4-4S19.2,4,17,4L17,4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOnIconWhite);
export default __webpack_public_path__ + "static/media/notification-on-icon-white.c5daf61dae8f66b63dce1e39098e0e6c.svg";
export { ForwardRef as ReactComponent };